module.exports = __webpack_public_path__ + "media/assets/images/claim-places/icon-error-7911c81673a6fc77d9b13ca0916d3159.svg";